/*
 * 1DS JS SDK Analytics, 3.2.12
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
/**
* ApplicationInsights.ts
* @author Abhilash Panwar (abpanwar) Hector Hernandez (hectorh)
* @copyright Microsoft 2018
* Main class containing all the APIs.
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { AppInsightsCore, doPerf, dumpObj, throwError, _throwInternal } from "@microsoft/1ds-core-js";
import { PropertiesPlugin } from "@microsoft/1ds-properties-js";
import { PostChannel } from "@microsoft/1ds-post-js";
var ApplicationInsights = /** @class */ (function (_super) {
    __extends(ApplicationInsights, _super);
    function ApplicationInsights() {
        var _this = _super.call(this) || this;
        var _postChannel;
        var _propertyManager;
        dynamicProto(ApplicationInsights, _this, function (_self, _base) {
            _self.initialize = function (config, extensions) {
                var _self = _this;
                doPerf(_this, function () { return "ApplicationInsights:initialize"; }, function () {
                    _postChannel = new PostChannel();
                    _propertyManager = new PropertiesPlugin();
                    var plugins = [_propertyManager];
                    if (extensions) {
                        plugins = plugins.concat(extensions);
                    }
                    if (!config) {
                        throwError("You must provide a config object!");
                    }
                    var channels = config.channels;
                    if (channels && channels.length > 0) {
                        // Add post channel to first fork if not available
                        var postFound = false;
                        for (var j = 0; j < channels[0].length; j++) {
                            if (channels[0][j].identifier === _postChannel.identifier) {
                                postFound = true;
                                break;
                            }
                        }
                        if (!postFound) {
                            channels[0].push(_postChannel);
                        }
                    }
                    else {
                        config.channels = [[_postChannel]];
                    }
                    var extConfig = config.extensionConfig = config.extensionConfig || [];
                    extConfig[_postChannel.identifier] = extConfig[_postChannel.identifier] || (config && config.channelConfiguration) || {};
                    extConfig[_propertyManager.identifier] = extConfig[_propertyManager.identifier] || (config && config.propertyConfiguration) || {};
                    try {
                        _base.initialize(config, plugins);
                    }
                    catch (error) {
                        _throwInternal(_self.logger, 1 /* eLoggingSeverity.CRITICAL */, 514 /* _eExtendedInternalMessageId.FailedToInitializeSDK */, "Failed to initialize SDK." + dumpObj(error));
                    }
                }, function () { return ({ config: config, extensions: extensions }); });
            };
            /**
             * Gets the property manager to set custom properties and system properties (part A), that should be applied
             * to all events or events with a specific instrumentation key.
             * @returns The property manager object.
             */
            _self.getPropertyManager = function () {
                return _propertyManager;
            };
            /**
             * Gets the post channel to configure and set the transmission profiles.
             * @returns The post channel object.
             */
            _self.getPostChannel = function () {
                return _postChannel;
            };
        });
        return _this;
    }
// Removed Stub for ApplicationInsights.prototype.initialize.
// Removed Stub for ApplicationInsights.prototype.getPropertyManager.
// Removed Stub for ApplicationInsights.prototype.getPostChannel.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ApplicationInsights.__ieDyn=1;

    return ApplicationInsights;
}(AppInsightsCore));
export default ApplicationInsights;
//# sourceMappingURL=ApplicationInsights.js.map